export default __webpack_public_path__ + "static/media/Funnel Icon.fd65e320.png";